import React, { Component } from "react";
import { Row, Col } from "antd";
import RcuControlNoChild from "../../components/RcuControls/RcuControlNoChild";
import RcuControlWithChild from "../../components/RcuControls/RcuControlWithChild";

class RcuGeneral extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  // RENDER
  mainControlRender = () => {
    const { rcuControlStore } = this.props;
    const { makeUpRoom, dnd } = rcuControlStore.deviceControl;
    const { master, masterShowDetail, masterOff } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        {/* Make Up Room */}
        <RcuControlNoChild
          Title="make.up.room"
          Icon="MakeUpRoomWhite.svg"
          isOn={makeUpRoom}
          onClick={() => rcuControlStore.setMakeUpRoom()}
          ShowSwitchText={true}
        />

        {/* DND */}
        <RcuControlNoChild
          Title="do.not.disturb"
          Icon="DndWhite.svg"
          isOn={dnd}
          onClick={() => rcuControlStore.setDnd()}
          ShowSwitchText={true}
        />

        {/* Master */}
        <RcuControlWithChild
          Title="master"
          Icon="LampOn.png"
          Device={master}
          ShowDetail={masterShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setMasterAllOff(),
            bright: () => rcuControlStore.setMasterBright(),
            soft: () => rcuControlStore.setMasterSoft(),
            setShowDetail: () => rcuControlStore.setmasterShowDetail(),
          }}
        />

        {/* Master Off */}
        <RcuControlNoChild
          Title="master.off"
          Icon="LampOn.png"
          isOn={masterOff}
          onClick={() => rcuControlStore.setMasterOff()}
          ShowSwitchText={true}
        />
      </React.Fragment>
    );
  };

  bathroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bathroom, bathroomShowDetail } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">
            Bathroom
          </div>
        </Col>

        {/* Bathroom */}
        <RcuControlWithChild
          Title="bathroom"
          Icon="LampOn.png"
          Device={bathroom}
          ShowDetail={bathroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setBathroomAllOff(),
            bright: () => rcuControlStore.setBathroomBright(),
            soft: () => rcuControlStore.setBathroomSoft(),
            setShowDetail: () => rcuControlStore.setbathroomShowDetail(),
          }}
        />
      </React.Fragment>
    );
  };

  livingroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { livingroom, livingroomShowDetail } = rcuControlStore.lampControl;
    const { blindUp, blindDown } = rcuControlStore.livingRoomControl;
    const { livingroomAc } = rcuControlStore;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">
            Living Room
          </div>
        </Col>

        {/* Living Room Lamp */}
        <RcuControlWithChild
          ColSpan={24}
          Title="livingroom"
          Icon="LampOn.png"
          Device={livingroom}
          ShowDetail={livingroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setLivingroomAllOff(),
            bright: () => rcuControlStore.setLivingroomBright(),
            soft: () => rcuControlStore.setLivingroomSoft(),
            setShowDetail: () => rcuControlStore.setlivingroomShowDetail(),
          }}
        />

        {/* Blind Up */}
        <RcuControlNoChild
          Title="blind.up"
          Icon="BlindUp.png"
          isOn={blindUp}
          onClick={() => rcuControlStore.setLivingRoomBlindUp()}
        />

        {/* Blind Down */}
        <RcuControlNoChild
          Title="blind.down"
          Icon="BlindDown.png"
          isOn={blindDown}
          onClick={() => rcuControlStore.setLivingRoomBlindDown()}
        />

        {/* Living Room AC */}
        <RcuControlNoChild
          Title="ac"
          Icon="AC.svg"
          isOn={livingroomAc}
          onClick={() => rcuControlStore.setLivingroomAc()}
          ShowSwitchText={true}
        />
      </React.Fragment>
    );
  };

  bedroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bedroom, bedroomShowDetail } = rcuControlStore.lampControl;
    const { bedroom2Ac } = rcuControlStore;
    const roomNo = JSON.parse(localStorage.getItem("roomNo") || "\"2701\"");
    const isHighZone07 = rcuControlStore.isHighZone07(roomNo);

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Bedroom</div>
        </Col>

        {/* Bedroom Lamp */}
        <RcuControlWithChild
          ColSpan={24}
          Title="bedroom"
          Icon="LampOn.png"
          Device={bedroom}
          ShowDetail={bedroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setBedroomAllOff(),
            bright: () => rcuControlStore.setBedroomBright(),
            soft: () => rcuControlStore.setBedroomSoft(),
            night: () => rcuControlStore.setBedroomNight(),
            readingleft: () => rcuControlStore.setBedroomReadingLeft(),
            readingright: () => rcuControlStore.setBedroomReadingRight(),
            table: () => rcuControlStore.setBedroomTable(),
            closet: () => rcuControlStore.setBedroomCloset(),
            setShowDetail: () => rcuControlStore.setbedroomShowDetail(),
          }}
        />

        {!isHighZone07 && (
          <RcuControlNoChild
            Title="ac"
            Icon="AC.svg"
            isOn={bedroom2Ac}
            onClick={() => rcuControlStore.setBedroom2Ac()}
            ShowSwitchText={true}
          />
        )}
      </React.Fragment>
    );
  };

  livingBedroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { blindUp, blindDown } = rcuControlStore.livingBedRoomControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">
            Living Room Bedroom
          </div>
        </Col>

        {/* Blind Up */}
        <RcuControlNoChild
          Title="blind.up"
          Icon="BlindUp.png"
          isOn={blindUp}
          onClick={() => rcuControlStore.setLivingBedRoomBlindUp()}
        />

        {/* Blind Down */}
        <RcuControlNoChild
          Title="blind.down"
          Icon="BlindDown.png"
          isOn={blindDown}
          onClick={() => rcuControlStore.setLivingBedRoomBlindDown()}
        />
      </React.Fragment>
    );
  };

  tableClosetControlRender = () => {
    const { rcuControlStore } = this.props;
    const { table, closet } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={12} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Table</div>
        </Col>
        <Col span={12} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Closet</div>
        </Col>

        {/* Table */}
        <RcuControlNoChild
          Title="table"
          Icon="LampOn.png"
          isOn={table}
          onClick={() => rcuControlStore.setTable()}
        />

        {/* Closet */}
        <RcuControlNoChild
          Title="closet"
          Icon="LampOn.png"
          isOn={closet}
          onClick={() => rcuControlStore.setCloset()}
        />
      </React.Fragment>
    );
  };

  render() {
    return (
      <>
        <Row className="row-rcu-menu">{this.mainControlRender()}</Row>

        <Row className="row-rcu-menu">{this.bathroomControlRender()}</Row>

        <Row className="row-rcu-menu">{this.bedroomControlRender()}</Row>

        <Row className="row-rcu-menu">{this.livingBedroomControlRender()}</Row>

        <Row className="row-rcu-menu">{this.tableClosetControlRender()}</Row>

        <Row className="row-rcu-menu">{this.livingroomControlRender()}</Row>
      </>
    );
  }
}

export default RcuGeneral;
